import * as yup from "yup";
import { cpf as cpfValidator } from "cpf-cnpj-validator";

const schema = yup.object().shape({
	name: yup.string().required("O campo Nome é obrigatório"),
	email: yup.string().required("O campo E-mail é obrigatório"),
	role_id: yup.string().required("Escolha o tipo de usuário"),
});

export default schema